import { useSelector } from 'react-redux';
import { getViewModuleTrackingAttributes } from 'helpers/tracking.helpers';
import { useSeenModulePixel } from 'hook/helper.hook';
import { AVAILABLE_FOR_YOU } from 'types/morph.pagePosition.constants';
import { useAvailableForYou } from './hooks/availableForYou.hook';
import AvailableForYouModuleView from './components/AvailableForYouModuleView';
import { isApplyToConfidence } from 'helpers/offer.helpers';

const AvailableForYouModuleController = props => {
  const { todayContainerModules } = useSelector(state => ({
    todayContainerModules: state?.todayContainer?.todayContainer?.modules,
  }));

  const availableForYouData = useAvailableForYou({ todayContainerModules });

  const trackingAtr = getViewModuleTrackingAttributes({
    pagePosition: AVAILABLE_FOR_YOU,
    modulePosition: props.modulePosition,
  });
  const seenModuleTracking = useSeenModulePixel(trackingAtr);
  const showAmexWithConfidence = isApplyToConfidence(
    availableForYouData?.creditCardOfferMetaData?.productKey,
  );

  return (
    <AvailableForYouModuleView
      {...props}
      {...availableForYouData}
      seenModuleTracking={seenModuleTracking}
      showAmexWithConfidence={showAmexWithConfidence}
    />
  );
};

export default AvailableForYouModuleController;
